export default __webpack_public_path__ + "static/es-c2bea6d740c5d81d5bce0d4ba6f8cded.svg";